export const API_BASE_URL = "https://api.invenstory.iosx.in/V2/api/v1/";
